import React, { FC } from "react";
import { View } from "react-native";
import Colors from "../../constants/Colors";

const Divider: FC<{ margin?: number; thickness?: number }> = ({
  margin,
  thickness,
}) => {
  return (
    <View
      style={{
        marginVertical: margin || 16,
        backgroundColor: Colors.borderColor,
        height: thickness || 1,
      }}
    ></View>
  );
};

export default Divider;
